import dynamic from 'next/dynamic';

const DynamicModal = dynamic(() => import('./Modal'), { ssr: false });

export default DynamicModal;

